/**
 * Text a screen reader reads and a sighted person does not see, such as "(opens in a new tab)"
 * after a link that shows an icon for it. The clip pattern rather than `display: none`, which would
 * hide it from the screen reader too.
 */
import * as stylex from "@stylexjs/stylex";
export const visuallyHidden = {
  hidden: {
    kVAEAm: "x10l6tqk",
    kzqmXN: "x1i1rx1s",
    kZKoxP: "xjm9jq1",
    kogj98: "xkdpibf",
    kmVPX3: "x1717udv",
    kVQacm: "xb3r6kr",
    kz4h6p: "x1hyvwdk",
    khDVqt: "xuxw1ft",
    kMzoRj: "xc342km",
    $$css: true
  }
};